const getDueDateDaysOptions = (daysNumber = null) =>
  Array.from({ length: daysNumber || 7 }, (_, index) => ({
    label: (index + 1).toString(),
    value: (index + 1).toString()
  }));

export default getDueDateDaysOptions;
